import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-margem-regua',
    templateUrl: './margem-regua.component.html',
    styleUrls: ['./margem-regua.component.css'],
    standalone: false
})
export class MargemReguaComponent {
  @Input() margem: number | null = null;

  get posicao(): string | null {
    if (this.margem == null || isNaN(this.margem)) return null;
    const clamped = Math.max(0, Math.min(this.margem, 100));
    return ((clamped / 100) * 98) + '%';
  }
}
